import { render, staticRenderFns } from "./refuseDialog.vue?vue&type=template&id=23e5d652&scoped=true"
import script from "./refuseDialog.vue?vue&type=script&lang=js"
export * from "./refuseDialog.vue?vue&type=script&lang=js"
import style0 from "./refuseDialog.vue?vue&type=style&index=0&id=23e5d652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e5d652",
  null
  
)

export default component.exports